import { groq } from "next-sanity"

import { groqQueryOptions } from "@/graphql/schemas/shared/utils/groqQueryOptions"
import { AppSettings } from "@/settings"

import { checkPermissions, isIdmUser, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { noteProjection } from "../sanity/note.projection"

export const queryNotes = {
  async notes(parent, args, context, info) {
    const {
      lang = AppSettings.defaultLocale(),
      cdn = true,
      offset,
      limit,
      sort,
      sortWithinLimits,
      customerNumber,
      noteNumber,
      displayDuringReceiptCreation,
    } = args

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.NOTES,
      operation: Operations.READ,
    })

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customerNumber,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })
    const { pipesAndLimits, draftsFilter } = groqQueryOptions({
      sort,
      offset,
      limit,
      sortWithinLimits,
      includeDrafts: true,
    })

    const customerNumberFilter = customerNumber ? `&& customerNumber == "${customerNumber}"` : ""
    const noteNumberFilter = noteNumber ? `&& noteNumber == "${noteNumber}"` : ""
    const displayDuringReceiptCreationFilter =
      typeof displayDuringReceiptCreation === "boolean"
        ? `&& displayDuringReceiptCreation == ${displayDuringReceiptCreation}`
        : ""

    const notes = await client.fetch(
      groq`{
        "total": count(*[_type=="note"]),
        "items": *[_type=="note" && status != "X" ${draftsFilter}${customerNumberFilter}${noteNumberFilter}${displayDuringReceiptCreationFilter}]${pipesAndLimits}{
          ${noteProjection()}
        }
      }`,
    )

    if (notes.items && notes.items.length !== 0) {
      const { items, total } = notes

      return {
        total,
        items,
        cartConfirmRequired: isIdmUser(user?.role),
      }
    }

    return null
  },
}
